import React, { useState } from 'react';
import toast from 'react-hot-toast';
import { useDispatch, useSelector } from 'react-redux';
import { faEnvelope, faWrench } from '@fortawesome/free-solid-svg-icons';

import { ERROR, START } from 'shared/data/quoteSteps';
import { selectAssemblyDataForActions } from 'shared/product_tabs/tab_assembly/slice/selectors';
import { doEmailQuote } from 'shared/product_tabs/tab_assembly/slice/thunks';
import { alert } from 'shared/product_tabs/alert/alertSlice';

import QuoteAction from 'shared/components/QuoteAction';
import EmailQuoteModal from 'shared/components/EmailQuoteModal';

const QuoteActionBar = () => {
  const dispatch = useDispatch();
  const [showEmailQuoteModal, setShowEmailQuoteModal] = useState(false);
  const {
    quote,
    quoteStep,
    parametersChanged,
    parameters,
  } = useSelector(selectAssemblyDataForActions);

  const onEmailQuote = () => {
    if (parametersChanged) {
      dispatch(alert({
        variant: 'danger',
        title: Spree.translations.parameters_have_changed_title,
        message: Spree.translations.parameters_have_changed,
      }));
    } else {
      setShowEmailQuoteModal(true);
    }
  };

  const dismissEmailQuoteModal = () => {
    setShowEmailQuoteModal(false);
  };

  const onSendEmailQuote = async (data) => {
    try {
      await dispatch(doEmailQuote({ data })).unwrap();
      toast(Spree.translations.email_quote_success, { type: 'success' });
    } catch (error) {
      toast(Spree.translations.email_quote_error, { type: 'error' });
    } finally {
      dismissEmailQuoteModal();
    }
  };

  const onCustomQuote = () => {
    // eslint-disable-next-line no-undef
    window.open(Spree.routes.new_custom_quote_request_url);
  };

  const disabled = quoteStep === START || quoteStep === ERROR;

  return (
    <div className="quote-action-bar">
      <div className="btn-group" role="group">
        <QuoteAction
          disabled={disabled}
          label="Email quote"
          onClick={onEmailQuote}
          icon={faEnvelope} />
        <QuoteAction
          href={Spree.routes.new_custom_quote_request_url}
          label="Custom Quote"
          onClick={onCustomQuote}
          icon={faWrench} />

        <EmailQuoteModal
          show={showEmailQuoteModal}
          quote={quote}
          onHide={dismissEmailQuoteModal}
          onSend={onSendEmailQuote}
          defaultEmail={parameters.email_address} />
      </div>
    </div>
  );
};

export default QuoteActionBar;
